<script setup lang="ts">
import { usePopupStore } from '@/stores/PopupStore'
import { computed } from 'vue'

const popupStore = usePopupStore()

const isVisible = computed(() => popupStore.isVisible)
const content = computed(() => popupStore.content)
const buttonText = computed(() => popupStore.buttonText)
const showLogout = computed(() => popupStore.showLogout)

function confirm() {
  popupStore.confirm()
}
function logout() {
  popupStore.logout()
}
</script>

<template>
  <div v-if="isVisible" class="popup-overlay">
    <div class="popup-container">
      <div class="popup-header">
        <i class="mdi mdi-information-outline popup-icon"></i>
        <h2 class="popup-title">Information</h2>
      </div>
      <div class="popup-content">
        <slot>{{ content }}</slot>
      </div>
      <div class="popup-actions">
        <!-- Logout Button -->
        <v-btn
          v-if="showLogout"
          @click="logout"
          class="popup-logout-button"
          variant="outlined"
          size="small"
        >
          Logout
        </v-btn>
        <!-- OK Button -->
        <v-btn @click="confirm" class="popup-ok-button" variant="outlined" size="small">
          {{ buttonText }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Popup Overlay */
.popup-overlay {
  position: fixed;
  inset: 0;
  /* shorthand for top, right, bottom, left */
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease-in-out;
}

/* Popup Container */
.popup-container {
  background: #ffffff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 400px;
  max-height: calc(100vh - 4rem);
  overflow-y: auto;
  position: relative;
  text-align: center;
  animation: scaleIn 0.3s ease-in-out;
  transform-origin: center;
}

/* Popup Header */
.popup-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.popup-icon {
  font-size: 28px;
  color: #036a01;
  margin-right: 10px;
}

.popup-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #333;
}

/* Popup Content */
.popup-content {
  font-size: 16px;
  line-height: 1.5;
  color: #444;
}

/* Popup Actions */
.popup-actions {
  margin-top: 20px;
  /* Padding above the button */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Add styles for the Logout button */
.popup-logout-button {
  margin-right: 10px; /* Space between buttons */
  border: 1px solid #ccc;
}

.popup-ok-button {
  border: 1px solid #ccc;
  /* Add a subtle border for visibility */
}

/* Animations */
@keyframes fadeIn {
  from {
    background: rgba(0, 0, 0, 0);
  }

  to {
    background: rgba(0, 0, 0, 0.6);
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.8);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
